<template>
  <v-row class="mt-2">
    <div class="d-flex flex-grow-1 pt-3 px-3">
      <px-search-text label="Busque por uma transportadora" v-model="searchText"
                      :on-search="onChangeSearchText"/>
    </div>
    <div class="d-flex my-3 mr-3">
      <v-btn icon color="primary" @click="emitRefresh">
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
      <px-select-menu prepend-icon="mdi-sort-variant"
                      v-model="selectedSort"
                      :options="sortOptions"
                      @change="onChangeSort"/>
    </div>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      searchText: null,
      selectedSort: null,
      sortOptions: [
        {
          description: 'Menor valor do frete',
          value: 'total',
        },
        {
          description: 'Menor valor sem ICMS',
          value: 'valorFrete',
        },
        {
          description: 'Menor prazo de entrega',
          value: 'prazoEntrega',
        },
      ],
    };
  },
  methods: {
    onChangeSearchText() {
      this.$emit('change-search-text', this.searchText);
    },
    onChangeSort() {
      this.$emit('change-sort', this.selectedSort);
    },
    emitRefresh() {
      this.$emit('refresh');
    },
  },
  created() {
    [this.selectedSort] = this.sortOptions;

    this.$emit('change-sort', this.selectedSort);
  },
};
</script>
